import {getEventDisplayName} from '../display-name-registry';

export function getIconForEvent(_event) {
  return _event.custom ? `custom` : `event`;
}

export function renameEvent(event) {
  return getEventDisplayName(event);
}
